import React from 'react';
import { Link } from "react-router-dom";
import { ReactComponent as LogoImg } from '../../img/logo.svg';
import '../../scss/header/logo.scss';

export default function Logo() {
        return (
            <>
                <Link to="/">
                    <LogoImg className='logo_img' />
                </Link>
                <h1 className='logo_title'>Reticle Editor</h1>
            </>
        )
    }
